import { useAppSettingsService } from "src/services/appSettingsService/appSettingsService";
import { useSelector } from "src/store";

import { selectProducts } from "../containers/dashboard/products/store/selectors/products";
import { getFeature } from "../containers/dashboard/shared/limits/utils";
import { useCurrentWorkspaceFeatures } from "../containers/dashboard/workspaces/api/helpers";

function useProductPageVisibility() {
    const { effectiveWorkspaceSettings } = useAppSettingsService();

    const { data: workspaceFeatures = [] } = useCurrentWorkspaceFeatures();
    const productManagement = getFeature("ProductManagement", workspaceFeatures);

    const products = useSelector(selectProducts);
    const hasProducts = products.length > 0;

    if (!effectiveWorkspaceSettings.isProductsPageEnabled) {
        return false;
    }

    if (hasProducts) {
        return true;
    }

    if (productManagement.used) {
        return true;
    }

    return false;
}

export { useProductPageVisibility };
